// extracted by mini-css-extract-plugin
module.exports = {"body-margin-top":"80px","body-margin-top-sm":"90px","primary":"#06c","custom-gray-100":"#F0F6FC"};